import { Button, ButtonSize, ButtonVariant, EmailInput } from '@hourly-hds/components';
import { useState } from 'react';
import StepLayout from '../StepLayout';

const EMAIL_REGEX = /^[\w-.+]+@([\w-]+\.)+[\w-]{2,}$/;

interface SignInProps {
  onSubmit: (email: string) => void;
  disabled?: boolean;
}

const SignIn = ({ disabled, onSubmit }: SignInProps) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    const isInvalidEmail = !EMAIL_REGEX.test(email);
    if (isInvalidEmail) {
      setError('Please enter a valid email');
      return;
    }

    onSubmit(email);
  };

  return (
    <StepLayout
      onKeyDown={(e) => {
        if (e.key === 'Enter' && !disabled && email) {
          e.preventDefault();
          handleSubmit();
        }
      }}>
      <StepLayout.Header>
        <StepLayout.Title>Good to see you</StepLayout.Title>
      </StepLayout.Header>

      <StepLayout.Content>
        <EmailInput
          label="Email Address"
          value={email}
          error={!!error}
          onChange={setEmail}
          disabled={disabled}
          description={error || 'We’ll email you a magic link to complete your login'}
        />
      </StepLayout.Content>

      <Button
        fullWidth
        label="Send Magic Link"
        size={ButtonSize.Large}
        onClick={handleSubmit}
        variant={ButtonVariant.Primary}
        disabled={disabled || !email}
      />
    </StepLayout>
  );
};

export default SignIn;
